import ReactComponent from '../app/ReactComponent'
import {Col, Layout, List, Row, Space, Spin, Tooltip, Typography} from 'antd'
import React from 'react'
import {Link} from 'react-router-dom'
import {LeftOutlined} from '@ant-design/icons'
import {MessagesResource} from '../resources/MessagesResource'
import {prettyDate, relativeTime} from '../helpers/utils'

export class NotificationsPage extends ReactComponent {
  state = {
    loading_page: false,
    notifications: [],
    overview: {
      pagination: {
        defaultCurrent: 1,
        total: 0,
        defaultPageSize: 10,
        current: 1
      }
    }
  }

  componentDidMount = async () => {
    this.pushPageAnalytics('Notifikace - Moje Amber')

    void this.getNotifications()
  }

  getNotifications = async (offset = this.state.overview.pagination.current) => {
    void this.updateState({
      loading_page: true
    })

    try {
      const messagesResource = new MessagesResource()
      const limit = this.state.overview.pagination.defaultPageSize
      const apiOffset = (offset - 1) * limit

      const {notifications = [], total_items = 0} = await messagesResource.getNotifications(limit, apiOffset)

      await this.updateState({
        loading_page: false,
        notifications: notifications,
        overview: {
          ...this.state.overview,
          pagination: {
            ...this.state.overview.pagination,
            total: total_items,
            current: offset
          }
        }
      })

      this.scrollToTop()

    } catch (error) {
      console.log(error)
      await this.updateState({
        loading_page: false
      })
    }
  }

  render() {
    return (
      <Layout tagName={'main'} className="notifications-page">
        <Row align="center">
          <Col xs={23} sm={24} xl={24} className="notifications-page-header-col">
            <Space className="title-with-btn" size={[0, 0]}>
              <Link to={'/'}><LeftOutlined/><span className="back-to-btn">Zpět na úvod</span></Link>
              <h1>Moje notifikace</h1>
            </Space>
            <h4>Přehled všech notifikací</h4>
          </Col>
          <Col xs={23} sm={24} xl={24} className="notifications-page-list-col">
            <Spin spinning={this.state.loading_page} size={'large'}>
              <List
                header="Název notifikace / Obsah / Datum a čas"
                pagination={{
                  defaultCurrent: this.state.overview.pagination.defaultCurrent,
                  total: this.state.overview.pagination.total,
                  defaultPageSize: this.state.overview.pagination.defaultPageSize,
                  current: this.state.overview.pagination.current,
                  showSizeChanger: false,
                  onChange: (page) => this.getNotifications(page)
                }}
                locale={{
                  emptyText: (
                    <div className="notifications-page-empty">
                      <p className="notifications-page-empty-title">Žádné notifikace</p>
                      <p className="notifications-page-empty-description">Momentálně nemáte žádné nové zprávy</p>
                    </div>
                  )
                }}
                dataSource={this.state.notifications}
                renderItem={(item) => (
                  <List.Item>
                    <Space direction="vertical" className="notifications-page-item-content">
                      <Typography.Title level={4} className="mt-1 mb-0">{item.title}</Typography.Title>
                      {item.html_body}

                      <div>

                        {item.button_text && item.button_link &&

                          <Typography.Link href={item.button_link} style={{textDecoration: 'underline', float: 'right'}}>{item.button_text} <span style={{fontFamily: 'Georgia, Helvetica, sans-serif', fontSize: '1.2em'}}>→</span></Typography.Link>

                        }

                        <Tooltip title={prettyDate(item.send_time)}>
                          <Typography.Text type="secondary">{relativeTime(item.send_time)}</Typography.Text>
                        </Tooltip>
                      </div>

                    </Space>
                  </List.Item>
                )}
              />
            </Spin>
          </Col>
        </Row>
      </Layout>
    )
  }
}
